import React from 'react';
import { StoryCard } from '../StoryCard';

class NavigationCard extends StoryCard {
	render() {
		return <div className="navigation-card">{super.renderCard()}</div>;
	}
}

export default NavigationCard;
